import { User } from '../profileService/ProfileServiceV2';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';

export class UserClient {

    constructor(private readonly authService: IAuthServiceV2) {
    };

    public async getCurrentUser(): Promise<User> {
        const response = await this.authService.get('', '../user');

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json() as User;
    }

}
